import {
    HttpWarehouseAllList
} from "@mods/service/dictionary.js";
export default {
    data () {
        return {
            warehouseList: []
        }
    },
    created () {
        this.getWarehouseAll();
    },
    methods: {
        getWarehouseAll () {
            HttpWarehouseAllList().then(res => {
                this.warehouseList = res.data.map(item => {
                    return {
                        value: item.id,
                        label: `${item.code}(${item.title})`,
                        attach: {
                            code:item.code,
                            warehouseType:item.warehouseType,
                            orgId:item.organizationId,
                            apiType:item.apiType
                        }
                    }
                });
            }, err => {});
        },
    }
}